import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import PageHeader from '../../Common/PageHeader';
import Icons from '../../../../components/Common/Icons/Icons';
import ContentCard from '../../Common/Card';
import MenuIcon from '../../Layout/Menu/MenuIcon';
import DataTable from '../../../../components/Common/UI/DataTable';
import { checkImagesCol, checkImagesData, ICheckImagesData } from './Data';
import Footer from '../../Layout/Footer';
import { Button } from '../../../../components/Common/UI/Button';
import { cn } from '../../../../utils/styles';
import TableFilters from './Filters';
import Tag from './Filters/Tag';

function CheckImages() {
  const [state, setState] = useState<ICheckImagesData[]>([]);
  const [showFilter, setShowField] = useState<boolean>(false);
  const [isModified, setModified] = useState<boolean>(false);

  useEffect(() => {
    setState(checkImagesData);
  }, []);

  const handleShowFilters = (payload: boolean) => {
    setShowField(payload);
  };

  const handleApplyFilters = (payload: boolean) => {
    setModified(payload);
    // toast.success('Filters applied!');
  };

  return (
    <div className="grid grid-rows-[auto,1fr]">
      <PageHeader
        icon={<Icons.UserCheck />}
        title="Check Images"
        actions={
          <Button
            variant="outline"
            className="p-[10px_15px] !text-white font-bold !bg-transparent border-white"
            onClick={() => handleShowFilters(!showFilter)}
          >
            Filters
          </Button>
        }
      />
      <div className="px-[20px] grid gap-[20px] ld:grid-rows-[1fr,auto]">
        <div className="lg:relative overflow-hidden lg:h-[660px] flex w-full rounded-[10px]">
          <div className={cn('w-full transition-all', { 'lg:w-[calc(100%-470px)]': showFilter })}>
            <ContentCard
              title={isModified ? 'Filter Result' : 'Recent checks'}
              icon={
                <MenuIcon
                  icon={isModified ? <Icons.Filters /> : <Icons.UserCheck />}
                  className="bg-primary border-primary"
                  variant="white"
                  size="large"
                />
              }
            >
              {/* {isModified ? (
                <div>
                  <div className="flex gap-[5px] items-center">
                    <div>Filters:</div>
                    <Tag label="Date" value="2021-03-20 - 2024-03-20" />
                    <Tag label="Amount" value="0" />
                  </div>
                  <div className="font-bold py-[30px] text-center">No Result Found</div>
                </div>
              ) : (
                <DataTable
                  responsive
                  variant="guidance2"
                  columns={checkImagesCol}
                  data={state}
                  paginationPosition="bottom"
                  paginationVariant="guidance"
                  initialState={{ pagination: { pageSize: 10 } }}
                />
              )} */}
              <>
                {isModified ? (
                  <div className="flex gap-[5px] items-center">
                    <div>Filters:</div>
                    <Tag label="Date" value={`2021-03-20 - ${dayjs().format('YYYY-MM-DD')}`} />
                    <Tag label="Amount" value="0" />
                  </div>
                ) : null}
                <DataTable
                  responsive
                  variant="guidance2"
                  columns={checkImagesCol}
                  data={state}
                  paginationPosition="bottom"
                  paginationVariant="guidance"
                  initialState={{ pagination: { pageSize: 10 } }}
                />
              </>
            </ContentCard>
          </div>
          <TableFilters open={showFilter} handleOpen={handleShowFilters} handleApplyFilters={handleApplyFilters} />
        </div>
        <Footer className="self-end" />
      </div>
    </div>
  );
}

export default CheckImages;
